import Chevron from 'public/chevron.svg';

import { ChevronIcon, PreviousButton, StyledStepCount } from './styles';

interface StepCountProps {
  currentStepIndex: number;
  totalSteps: number;
  hideCount: boolean;
  showPreviousButton: boolean;
  showCountDesktop?: boolean;
  handlePrev?: () => void;
  customHandlePrevText?: string;
}

export const StepCount = ({
  currentStepIndex,
  totalSteps,
  hideCount,
  showPreviousButton = true,
  handlePrev,
  customHandlePrevText = null,
}: StepCountProps) => {
  return (
    <StyledStepCount>
      {showPreviousButton && (
        <PreviousButton onClick={handlePrev}>
          <ChevronIcon src={Chevron} />
          {currentStepIndex === 0 ? customHandlePrevText ?? 'Home' : 'Previous'}
        </PreviousButton>
      )}
      {!hideCount && (
        <div>
          {currentStepIndex + 1} of {totalSteps}
        </div>
      )}
    </StyledStepCount>
  );
};
